<template>
  <b-modal size="modal-xl" id="infoModal" ref="info-modal" :title="infoModal.modalData.title" :header-bg-variant="'secondary'" scrollable hide-backdrop okVariant="secondary" ok-only @hide="resetModal" @show="fetchInfo(infoModal.batchData)" style="min-width: 70% !important;">
    <template slot="modal-header" slot-scope="{ close }">
      <h5 class="modal-title text-light"><fontAwesomeIcon :icon="['fa', 'info']" size="1x" class="mr-2"/> {{ infoModal.modalData.title }}</h5>
      <button aria-label="Close" class="close" data-dismiss="modal" type="button" @click="close()"><span aria-hidden="true" class="text-light">X</span></button>
    </template>
    <template slot="default">
      <div class="vld-parent text-center">
        <div autofocus>
          <!--<div @transitioncancel="loaderStopped">-->
            <loading
            :active.sync="infoIsBusy"
            :can-cancel="false"
            :color="'#047bf8'"
            :loader="'dots'"
            :is-full-page="false"></loading>
          <!--</div>-->
          <div v-if="infoIsBusy === false" >
            <table v-if="infoModal.batchData" class="table info-table">
              <tr v-if="userLevel == '3.00'">
                <td class="text-white">{{ t('labelId','labelId') }}</td>
                <td>{{ infoModal.batchData.id }}</td>
              </tr>
              <tr v-if="infoModal.batchData.batch_type">
                <td class="text-white">{{ t('labelBatchType','labelBatchType') }}</td>
                <td v-if="userLevel == '3.00'" class="">
                  <router-link :to="{name: 'core_types', props: { id: infoModal.batchData.id}}" >{{ infoModal.batchData['batch_type'].name }}</router-link>
                </td>
                <td v-else class="">{{ infoModal.batchData['batch_type'].name }}</td>
              </tr>
              <tr>
                <td class="text-white">{{ t('labelBatchPrinciple','labelBatchPrinciple') }}</td>
                <td v-if="infoModal.batchData.principal" class="text-center">{{ infoModal.batchData.principal }}</td>
                <td v-else class="">{{ t('labelBatchPrincipleOnMultiple', 'labelBatchPrincipleOnMultiple') }}</td>
              </tr>
              <tr>
                <td class="text-white">{{ t('labelSplitter','labelSplitter') }}</td>
                <td class=""> {{ infoModal.batchData.splitter }}</td>
              </tr>
              <tr>
                <td class="text-white">{{ t('labelTestMode','labelTestMode') }}</td>
                <td class=""> {{ infoModal.batchData.test_mode }}</td>
              </tr>
              <tr v-if="infoModal.batchData.parent_batch">
                <td class="text-white">{{ t('labelBatchParent','labelBatchParent') }}</td>
                <td>
                  <a href="#" @click.stop.prevent="parentInfo()">{{ infoModal.batchData.parent_batch }}</a>
                </td>
              </tr>
              <tr v-if="infoModal.batchData.tester_email">
                <td class="text-white">{{ t('labelTesterEmail','labelTesterEmail') }}</td>
                <td class=""> {{ infoModal.batchData.tester_email }}</td>
              </tr>
              <tr>
                <td class="text-white">{{ t('labelAddedBy','labelAddedBy') }}</td>
                <td v-if="batchInfo.username" class=""> {{ batchInfo.username }} <span class="font-italic text-muted">({{ batchInfo.email }})</span></td>
                <td v-else> {{ t('labelNoUserForBatchInfo','labelNoUserForBatchInfo') }} </td>
              </tr>
              <tr>
                <td class="text-white">{{ t('labelNumOfDocs','labelNumOfDocs') }}</td>
<!--                EIPP-574 showing if the count of the documents is 0 insted of showing empty value -->
                <td> {{ batchInfo.document_count }} </td>
<!--                <td v-if="batchInfo.document_count" class=""> {{ batchInfo.document_count }} </td>-->
<!--                <td v-else> </td>-->
              </tr>
            </table>
            <div v-if="batchInfo.generate_job">
              <h5 class="text-center py-2">{{ t('batchInfoModalGenStatus','batchInfoModalGenStatus') }}</h5>
              <table class="table info-table">
                <tr>
                  <td class="text-white">{{ t('labelStatus','labelStatus') }}</td>
                  <td class="">{{batchInfo.generate_job.status}}</td>
                </tr>
                <tr>
                  <td class="text-white">{{ t('labelLog','labelLog') }}</td>
                  <td><textarea class="log-textbox text-muted" rows="15" cols="50" readonly>{{ batchInfo.generate_job.log }}</textarea></td>
                </tr>
                <tr>
                  <td class="text-white">{{ t('labelStartAfter','labelStartAfter') }}</td>
                  <td class="">{{batchInfo.generate_job.start_after | humanReadable}}</td>
                </tr>
              </table>
            </div>
            <div v-if="userLevel == '3.00'">
              <div v-if="(batchInfo.posting) && (batchInfo.posting.post_houses.length)">
                <h5 class="text-center py-2">{{ t('batchInfoModalPosting','batchInfoModalPosting') }}</h5>
                <table class="table info-table">
                  <tr v-for="ph in batchInfo.posting.post_houses" :key="ph.id">
                    <td class="text-white">{{ ph.name }}</td>
                    <td> {{ ph.number_of_docs }}</td>
                  </tr>
                  <tr>
                    <td class="text-white">{{ t('labelNotOutsourced','labelNotOutsourced') }}</td>
                    <td> {{ batchInfo.posting.not_outsourced }}</td>
                  </tr>
                </table>
              </div>
              <div v-if="(batchInfo.posting_enabled) && (batchInfo.posting_enabled.post_houses.length)">
                <h5 class="text-center py-2">{{ t('batchInfoModalPostEnabled','batchInfoModalPostEnabled') }}</h5>
                <table class="table info-table">
                  <tr v-for="ph in batchInfo.posting_enabled.post_houses" :key="ph.id">
                    <td class="text-white">{{ ph.name }} {{t('labelPostEnabled','labelPostEnabled')}}</td>
                    <td> {{ ph.number_of_docs }}</td>
                  </tr>
                  <tr>
                    <td class="text-white">{{ t('labelNotOutsourcedPostEnabled','labelNotOutsourcedPostEnabled') }}</td>
                    <td> {{ batchInfo.posting_enabled.not_outsourced }}</td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
import ResponseInfo from '@/components/ResponseInfo.vue'
import Loading from 'vue-loading-overlay'

export default {
  name: 'ModalInfoBatch',
  //this component inherits from the ManageBatches.vue component
  inject: [
    'resetModal',
    'modalCreator',
    'userLevel'
  ],
  data () {
    return {
      infoModal: {},
      infoIsBusy: false,
      loaderBusy: true
    }
  },
  computed: {
    batchInfo: {
      get(){
        return this.$store.getters.getBatchInfo
      },
      set(info) {
        this.$store.commit('setBatchInfo', info)
      }
    }
  },
  methods: {
    fetchInfo(batchData) {
      this.loaderBusy = true
      this.infoIsBusy = true
      this.$store.dispatch('getBatchInfo',{
        batchId: batchData.id,
        parentBatchId: batchData.parent_batch,
        userId: batchData.added_by
      })
      .then(() => {
        this.infoIsBusy = false
      })
    },
    parentInfo() {
      this.infoIsBusy = true
      this.infoModal.batchData = { ...this.infoModal.batchData.parent }
      this.$store.dispatch('getBatchInfo',{
        batchId: this.infoModal.batchData.id,
        parentBatchId: this.infoModal.batchData.parent_batch,
        userId: this.infoModal.batchData.added_by
      })
      .then(() => {
        this.infoIsBusy = false
      })
    },
    loaderStopped(){
      this.loaderBusy = false
    }
  },
  created() {
    this.infoModal = this.$attrs.modal
  },
  filters:{
    humanReadable: function(date) {
      return moment(date).format('MMMM Do YYYY, h:mm:ss a');
    }
  },
  components:{
    ResponseInfo,
    Loading
  }
}
</script>

<style scoped>
.button-h {
  max-height: 30px;
}
/*-----Batch Info Modal Styles*/
.modal-open #infoModal___BV_modal_outer_ >>> .modal-content{
  min-width: 700px !important;
  max-width: auto !important;
  width: auto !important;
}
.modal-open #infoModal___BV_modal_outer_ >>> .modal-content .modal-body{
  max-height: 450px;
  overflow-y: scroll;
}
.log-textbox{
  resize: none;
  border-radius: 5px;
  border: 1px solid lightgrey;
}

.info-table tr td:nth-of-type(1){
  background-color: #34495e;
  width: 200px;
}
</style>
